module.exports = __webpack_public_path__ + "media/images/sample/banner-0cff67eeb8c6fe387cf31e5f98de49ae.png";